import React from 'react';

const FiltersContext = React.createContext({
	filters: {},
	filterOpenHandler: () => {},
	filterCheckHandler: () => {},
	filterRangeHandler: () => {},
});

export default FiltersContext
